import { defineComponent as _defineComponent } from 'vue'
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import WidgetContainer from '@/components/Charts/widgetContainer/WidgetContainer.vue';
import DateGroupingFilter from '@/components/DateGroupingFilter.vue';
import WidgetDefinition from '@/models/Charts/widgetDefinition';
import {
  CompositeWidgetDefinition,
  CompositeWidgetEntry,
  WidgetEntry,
} from '@/models/Charts/compositeWidgetDefinition';
import { WidgetEnum } from '@/models/enums/WidgetEnum';
import { dateRangeToDateStrings, yearToDate } from '@/utils/dates';
import LayoutGrid from '../dashboard/LayoutGrid.vue';
import {
  availableDashboardLayouts,
  DashboardLayout,
} from '@/models/Charts/dashboardDefinition';
import { indexedWidgetDefinitions } from '@/utils/misc';
import { computed, ref, watch } from 'vue';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Quotes',
  setup(__props) {

const { t } = useI18n();

const gridLayout = availableDashboardLayouts[DashboardLayout.TwoByThree];

const selectedTimeAxisSpan = ref<FilterTimeAxisSpanEnum>(
  FilterTimeAxisSpanEnum.Month,
);
const dateRangeSelection = ref<[Date, Date]>(yearToDate());
const datepickerRef = ref<any>();

const dateRangeString = computed<[string, string]>(() =>
  dateRangeToDateStrings(dateRangeSelection.value),
);

const topQuotedMaterialsTimelineWidgetDefinition = new WidgetDefinition(
  WidgetEnum.QuotesTopQuotedMaterialsTimeline,
  [],
  dateRangeString.value,
  [],
  undefined,
  selectedTimeAxisSpan.value,
);

const quotedMaterialsListWidgetDefinition = new WidgetDefinition(
  WidgetEnum.QuotesQuotedMaterialsList,
  [],
  dateRangeString.value,
  [],
  undefined,
  selectedTimeAxisSpan.value,
);

const widgetDefinitions = ref<WidgetEntry[]>(
  indexedWidgetDefinitions([
    new WidgetDefinition(
      WidgetEnum.QuotesConvertedAmountTimeline,
      [],
      dateRangeString.value,
      [],
      undefined,
      selectedTimeAxisSpan.value,
    ),
    new WidgetDefinition(
      WidgetEnum.QuotesAbcCustomers,
      [],
      dateRangeString.value,
      [],
      undefined,
      selectedTimeAxisSpan.value,
    ),
    new WidgetDefinition(
      WidgetEnum.QuotesConversionRates,
      [],
      dateRangeString.value,
      [],
      undefined,
      selectedTimeAxisSpan.value,
    ),
    new WidgetDefinition(
      WidgetEnum.QuotesSize,
      [],
      dateRangeString.value,
      [],
      undefined,
      selectedTimeAxisSpan.value,
    ),
    new WidgetDefinition(
      WidgetEnum.QuotesFigures,
      [],
      dateRangeString.value,
      [],
      undefined,
      selectedTimeAxisSpan.value,
    ),
    new CompositeWidgetDefinition(
      new CompositeWidgetEntry(
        topQuotedMaterialsTimelineWidgetDefinition,
        'calendar',
      ),
      new CompositeWidgetEntry(
        quotedMaterialsListWidgetDefinition,
        'format-list-bulleted-type',
      ),
    ),
  ]),
);

function updateWidgetDefinition(
  index: number,
  newWidgetDefinition: WidgetEntry,
) {
  // It's necessary because 'splice' triggers reactivity
  // It appears that Vue is able to track the removal and insertion of the element, not just the direct change in the index.
  widgetDefinitions.value.splice(index, 1, newWidgetDefinition);
}

function toggleDatepicker() {
  datepickerRef.value?.toggle();
}

watch(
  () => [dateRangeString.value, selectedTimeAxisSpan.value],
  () => {
    widgetDefinitions.value = widgetDefinitions.value.map((item) =>
      item.isComposite()
        ? item.updateAndGetCopy({
            timeFilter: dateRangeString.value,
            axisSpan: selectedTimeAxisSpan.value,
          })
        : (item as WidgetDefinition).getCopy({
            timeFilter: dateRangeString.value,
            axisSpan: selectedTimeAxisSpan.value,
          }),
    );
  },
);

return { __sfc: true,t, gridLayout, selectedTimeAxisSpan, dateRangeSelection, datepickerRef, dateRangeString, topQuotedMaterialsTimelineWidgetDefinition, quotedMaterialsListWidgetDefinition, widgetDefinitions, updateWidgetDefinition, toggleDatepicker, WidgetContainer, DateGroupingFilter, LayoutGrid }
}

})